export default __webpack_public_path__ + "static/media/home-design-agency-img-04.ed4f2881.jpg";